import * as React from 'react';
import { observer } from 'mobx-react';
import { Breakpoints, ContentSpacing } from '@estee/elc-base-theme';
import { Desktop, Mobile } from '@estee/elc-layouts';
import styled from 'styled-components';
import { SocialProofReview } from './SocialProofReview';
import { SOCIAL_PROOF_REVIEW_RESPONSIVE_WRAPPER } from '../constants/DataTestIds';
import { classes } from '~utils/Classes';

const SocialProofReviewWrapper = styled.span`
    margin-right: ${ContentSpacing.space8};
`;
export interface ISocialProofReviewResponsiveWrapperProps {
    desktopHeadline: string;
    mobileHeadline: string;
}

export const SocialProofReviewResponsiveWrapper = observer(
    function SocialProofReviewResponsiveWrapper({
        desktopHeadline,
        mobileHeadline
    }: ISocialProofReviewResponsiveWrapperProps) {
        if (!desktopHeadline && !mobileHeadline) {
            return null;
        }
        const socialProofReviewResponsiveWrapperClassNames = classes(
            SOCIAL_PROOF_REVIEW_RESPONSIVE_WRAPPER
        );

        return (
            <SocialProofReviewWrapper
                data-test-id={SOCIAL_PROOF_REVIEW_RESPONSIVE_WRAPPER}
                className={socialProofReviewResponsiveWrapperClassNames}
            >
                <Desktop minWidth={Breakpoints.desktop}>
                    {() => <SocialProofReview reviewHeadline={desktopHeadline} />}
                </Desktop>
                <Mobile maxWidth={Breakpoints.desktop - 1}>
                    {() => <SocialProofReview reviewHeadline={mobileHeadline} />}
                </Mobile>
            </SocialProofReviewWrapper>
        );
    }
);
